import { Injectable } from '@angular/core';
import { Model } from 'survey-core';

@Injectable({
  providedIn: 'root'
})
export class SurveyNavigationErrorsService {
  surveyModel!: Model;
  ignoreValidations?: boolean;
}
